import { createSelector } from '@ngrx/store';
import { getMultipleOrderOnlineState } from '../reducers';

export const scheduleOrderConfirmationsState = createSelector(getMultipleOrderOnlineState, state => !!state && state.orderConfirmation);

export const loadOrderConfirmation = createSelector(scheduleOrderConfirmationsState, state => state.loading);

export const getOrderConfirmation = createSelector(scheduleOrderConfirmationsState, state => !!state && state.groupOrderRequest);

export const getOrderConfirmationGroupId = createSelector(getOrderConfirmation, state => !!state  && state.id);
